module.exports = __webpack_public_path__ + "static/media/Kjole.fa1687fe.PNG";